
<div v-if="site && value">
    <inc-warranty
        v-model     = "component.showDialog"
        :warrenties = "incident.warrenties"
        :component  = "component.selected"
    />

    <div class="component-label primary--text">
        <div class="component-zoom" v-if="zoomAllowed">
            <a @click = "onZoom">
                <v-icon size="20" color="primary">mdi-loupe</v-icon>
            </a>
        </div>
        {{ title }}
    </div>

    <div class="component-box lm-border">
        <div class="component-all primary--text" v-if="selected && selected.length > 1 && isWarrantyRelevant">
            <v-checkbox
                v-model = "warranty"
                :ripple = "false"
                class   = "component-checkbox"
                @click  = "onSelectAll"
                hide-details
                dense
            />

            <div class="component-font primary--text">{{ $t('inc.edit.invoice.allComponents') }}</div>
            <v-spacer />

            <div class="component-date-all">
                <f-date-picker
                    v-model       = "warrantyDate"
                    :time         = "false"
                    :hide-details = "true"
                    class         = "primary--text"
                    @change       = "onInput"
                    dense
                />
            </div>
        </div>
        <div style="overflow: auto" :style="'max-height: ' + height + 'px; '">
            <div v-for="(item,index) in value" :key="index">
                <div class = "component-item">
                    <!-- Warranty Checkbox -->
                    <div>
                        <v-checkbox
                            v-model = "item.warranty"
                            :ripple = "false"
                            class   = "component-checkbox"
                            @click  = "onSelect(item)"
                            hide-details
                            dense
                        />
                    </div>
                    <!-- Warranty Checkbox -->

                    <div style="width: calc(100% - 178px);">
                        <a @click="onAction(item)">
                            <div class="v-flex w-100">
                                <div class="action-icon">
                                    <i  :class="action(item).clazz" class="fa-sm" />
                                </div>

                                <div class="component-font" style="width: calc(100% - 25px);max-width: calc(100% - 25px);">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <div
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                {{ name (item) }}
                                            </div>
                                        </template>
                                        <span>{{ name (item) }}</span>
                                    </v-tooltip>
                                </div>
                            </div>
                        </a>
                    </div>

                    <!-- Warranty date -->
                    <div class="component-date">
                        <!-- ... if selected -->
                        <f-date-picker
                            v-if          = "item.warranty"
                            v-model       = "item.warrantyDate"
                            :time         = "false"
                            :hide-details = "true"
                            dense
                        />
                        <!-- ... if selected -->

                        <!-- ... if not selected -->
                        <div
                            v-if="!item.warranty"
                            class="component-date-not-selected"
                        >

                        </div>
                        <!-- ... if not selected -->
                    </div>
                    <!-- Warranty date -->

                    <div class="warranty-icon">
                        <a @click.stop="onWarranty (item.component)" v-if="hasWarranty(item.component)">
                            <i class="fas fa-exclamation-triangle error--text" />
                        </a>
                    </div>

                    <div class="remove-icon">
                        <a @click="onRemove(item)">
                            <v-icon color="error" size="18">mdi-delete</v-icon>
                        </a>
                    </div>
                </div>

            </div>
        </div>

        <v-autocomplete
            dense
            multiple
            flat
            deletable-chips
            filled
            chips
            auto-select-first
            :items           = "items"
            item-value       = "component.id"
            item-text        = "component.fullname"
            background-color = "white"
            v-model          = "selected"
            @change          = "onChange"
            :rules           = "[ componetsRule ]"
            hide-selected
            style="margin-top: 3px"
            ref = "input"
        >
            <template v-slot:selection="">
            </template>

            <template v-slot:item="data">
                <v-list-item-content>
                    <v-list-item-title class="component-title" v-html="data.item.component.name"></v-list-item-title>
                    <v-list-item-subtitle v-html="data.item.component.groupname"></v-list-item-subtitle>
                </v-list-item-content>
            </template>
        </v-autocomplete>
    </div>
</div>
